// extracted by mini-css-extract-plugin
export default {"menu":"MenuItem_menu__C+lCq","scrolableContainer":"MenuItem_scrolableContainer__oXHQ7"};